import { create } from 'zustand';

export const useStoreVisibleItems = create((set) => ({
  visibleItemsMap: new Map(),

  setVisibleItems: (category_uuid, items) =>
    set((state) => {
      const newMap = new Map(state.visibleItemsMap);
      newMap.set(category_uuid, items);
      return { visibleItemsMap: newMap };
    }),

  getVisibleItems: (category_uuid) => {
    return get().visibleItemsMap.get(category_uuid) || [];
  },
}));
